import type { SegmentSummary } from '@/domains/pages/ai-proficiency/utils/map-segment-aggregates';
import type { SegmentKind } from '@/domains/pages/ai-proficiency/utils/segment-api-payloads';
import { humanizeString } from '@/utils/string.utils';
import { translate } from '@/utils/translations';

export function applySegmentDisplayNames(
  segments: SegmentSummary[],
  humanize: boolean,
  segmentKind?: SegmentKind | null,
): SegmentSummary[] {
  if (segmentKind === 'tenure') {
    return segments.map((segment) => ({
      ...segment,
      displayName: translate('tenure', segment.name),
    }));
  }

  if (!humanize) return segments;

  return segments.map((segment) => ({
    ...segment,
    displayName: humanizeString(segment.name),
  }));
}

export function getSegmentDisplayName(
  name: string,
  segments: SegmentSummary[],
  humanize: boolean,
  segmentKind?: SegmentKind | null,
): string {
  if (segmentKind === 'tenure') {
    const segment = segments.find((item) => item.name === name);
    if (segment?.displayName) return segment.displayName;
    return translate('tenure', name);
  }

  const segment = segments.find((item) => item.name === name);
  if (segment?.displayName) return segment.displayName;
  return humanize ? humanizeString(name) : name;
}

export function humanizeMappedTeamName(name: string, humanize: boolean): string {
  if (!humanize || name === 'Others') return name;
  return humanizeString(name);
}
